import React, { useState } from "react";
import {
  Button,
  Box,
  Grid,
  TextField,
  IconButton,
  Typography,
  InputAdornment,
  alpha,
} from "@mui/material";
import { IoCall, IoChevronDown, IoChevronUp } from "react-icons/io5";
import { useSelector } from "react-redux";

const DialPad = ({
  dialNumber = "",
  setDialNumber = () => {},
  sendDTMF = () => {},
  handleDial = () => {},
}) => {
  const [showDialpad, setShowDialpad] = useState(true);
  const userInfo = useSelector((state) => state.userInfo.user);

  const buttons = [
    { number: "1", letters: "" },
    { number: "2", letters: "ABC" },
    { number: "3", letters: "DEF" },
    { number: "4", letters: "GHI" },
    { number: "5", letters: "JKL" },
    { number: "6", letters: "MNO" },
    { number: "7", letters: "PQRS" },
    { number: "8", letters: "TUV" },
    { number: "9", letters: "WXYZ" },
    { number: "*", letters: "" },
    { number: "0", letters: "+" },
    { number: "#", letters: "" },
  ];

  const handleAppendNumber = (number) => {
    sendDTMF(number);
    setDialNumber((prev) => prev + number);
  };

  const handleToggleDialpad = () => {
    setShowDialpad(!showDialpad);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Phone Number Input */}
      <TextField
        fullWidth
        variant="standard"
        label="Phone number"
        value={dialNumber}
        onChange={(e) => setDialNumber(e.target.value)}
        placeholder="Enter phone number"
        sx={{
          mb: 3,
          py: 2,
          "& .MuiInputLabel-root": {
            color: "#6B7280",
            fontSize: "0.875rem",
          },
          "& .MuiInput-root": {
            fontSize: "1.125rem",
            fontWeight: 500,
            "&:before": {
              borderBottomColor: "#E5E7EB",
            },
            "&:hover:not(.Mui-disabled):before": {
              borderBottomColor: "#667eea",
            },
            "&:after": {
              borderBottomColor: "#667eea",
            },
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={handleDial}
                title="Make call"
                disabled={!dialNumber.trim()}
                sx={{
                  backgroundColor: dialNumber.trim() ? "#10B981" : "#E5E7EB",
                  color: "white",
                  width: 40,
                  height: 40,
                  mt: -2,
                  "&:hover": {
                    backgroundColor: dialNumber.trim() ? "#059669" : "#E5E7EB",
                  },
                  "&:disabled": {
                    backgroundColor: "#E5E7EB",
                    color: "#9CA3AF",
                  },
                }}
              >
                <IoCall size={20} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* Dialpad Grid */}
      {showDialpad && (
        <Box sx={{ mb: 2 }}>
          <Grid container spacing={1.5}>
            {buttons.map((button, index) => (
              <Grid item xs={4} key={index}>
                <Box
                  onClick={() => handleAppendNumber(button.number)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "70px",
                    borderRadius: "12px",
                    backgroundColor: "#F9FAFB",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    border: "1px solid transparent",
                    "&:hover": {
                      backgroundColor: "#667eea",
                      color: "white",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                      "& .MuiTypography-root": {
                        color: "white",
                      },
                    },
                    "&:active": {
                      transform: "translateY(0)",
                    },
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      color: "#1F2937",
                      lineHeight: 1,
                      mb: 0.5,
                    }}
                  >
                    {button.number}
                  </Typography>
                  {button.letters && (
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "0.688rem",
                        color: "#6B7280",
                        fontWeight: 500,
                        letterSpacing: "0.5px",
                      }}
                    >
                      {button.letters}
                    </Typography>
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* Toggle Button */}
      <Button
        onClick={handleToggleDialpad}
        fullWidth
        sx={{
          mt: 1,
          py: 1.5,
          color: "#667eea",
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.938rem",
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: alpha("#667eea", 0.08),
          },
        }}
      >
        {showDialpad ? (
          <>
            Hide keypad
            <IoChevronUp size={18} />
          </>
        ) : (
          <>
            Show keypad
            <IoChevronDown size={18} />
          </>
        )}
      </Button>
    </Box>
  );
};

export default DialPad;
